/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * ITKSEC Permission Enum
 */
export enum ITKSECPermissionGroups {
    /**
     * User Permission
     */
    UserPermissions = 301000,
}
